import { createMuiTheme } from "@material-ui/core/styles";
import { merge } from "lodash";
import base, { images as baseImages } from "./base";
import redLight, { images as redLightImages } from "./red/redLight";
import blueLight, { images as blueLightImages } from "./blue/blueLight";
import blueDark, { images as blueDarkImages } from "./blue/blueDark";
import redDark, { images as redDarkImages } from "./red/redDark";
import baseLight, { images as baseLightImages } from "./baseLight";
import baseDark, { images as baseDarkImages } from "./baseDark";
import { THEMES } from "./constants";
export { THEMES, IMAGES, TYPES } from "./constants";
// env with domain name https://track.dpdlocal.co.uk/ should use blue based theme
export const defaultThemeName = window.location.hostname.includes("local") ? THEMES.BLUE_LIGHT : THEMES.RED_LIGHT;
const themes = {
  [THEMES.RED_LIGHT]: createMuiTheme(merge({}, base, baseLight, redLight)),
  [THEMES.RED_DARK]: createMuiTheme(merge({}, base, baseDark, redDark)),
  [THEMES.BLUE_LIGHT]: createMuiTheme(merge({}, base, baseLight, blueLight)),
  [THEMES.BLUE_DARK]: createMuiTheme(merge({}, base, baseDark, blueDark))
};
const images = {
  [THEMES.RED_LIGHT]: merge({}, baseImages, baseLightImages, redLightImages),
  [THEMES.RED_DARK]: merge({}, baseImages, baseDarkImages, redDarkImages),
  [THEMES.BLUE_LIGHT]: merge({}, baseImages, baseLightImages, blueLightImages),
  [THEMES.BLUE_DARK]: merge({}, baseImages, baseDarkImages, blueDarkImages)
};

const getTheme = themeName => themes[themeName];

export const inverseThemeName = themeName => {
  switch (themeName) {
    case THEMES.RED_LIGHT:
      return THEMES.RED_DARK;

    case THEMES.RED_DARK:
      return THEMES.RED_LIGHT;

    case THEMES.BLUE_LIGHT:
      return THEMES.BLUE_DARK;

    case THEMES.BLUE_DARK:
      return THEMES.BLUE_LIGHT;

    default:
      throw new Error(`Invalid themeName equal to ${themeName} has been passed`);
  }
};
export const getImageSrc = (imageName, themeName) => images[themeName][imageName];
export default getTheme;